import { render, staticRenderFns } from "./ListRegions.vue?vue&type=template&id=78bd5002&lang=pug"
import script from "./ListRegions.vue?vue&type=script&lang=js"
export * from "./ListRegions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports